import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import Users from "@/pages/admin/Users";
import { buildSeoHead, publicPageSeo } from "@/data/seo";

export const Route = createFileRoute("/admin/users")({
  head: () =>
    buildSeoHead(
      { ...publicPageSeo.home, key: "admin-users", path: "/admin/users", title: "Cloud Admin Users", description: "Administrationsyta" },
      [],
      { noindex: true },
    ),
  component: () => <AdminLayout><Users /></AdminLayout>,
});
